__turbopack_context__.v({
  "tabs": "Tabsbar-module__lmDeiW__tabs",
});
